import React from "react"

export const ScreenSizeContext = React.createContext<number>(window.innerWidth)
